module.exports = __webpack_public_path__ + "static/img/phone.d4642770.svg";